function formatMoney(money) {
  return parseFloat(money).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export default formatMoney;
